import Vue from "vue";
import VueI18n from "vue-i18n";
// 引入自定义的各个语言配置文件
import zh from "./config/zh";
import zhFan from "./config/zh-fan";
import en from "./config/en";
import malai from "./config/malai";
import yinni from "./config/yinni";
import vietnam from "./config/vietnam";
import th from "./config/th";
import adminMessages from "./admin";

Vue.use(VueI18n);

// 各个国家语言包
const messages = {
  en: {
    ...en,
    admin: adminMessages.en,
  },
  zh: {
    ...zh,
  },
  ms: {
    ...malai,
    admin: adminMessages.ms,
  },
  vi: {
    ...vietnam,
    admin: adminMessages.vi,
  },
  "zh-TW": {
    ...zhFan,
    admin: adminMessages["zh-TW"],
  },
  in: {
    ...yinni,
    admin: adminMessages.id,
  },
  id: {
    ...yinni,
    admin: adminMessages.id,
  },
  th: {
    ...th,
  },
};
const i18n = new VueI18n({
  locale: "zh", // set default locale
  messages,
  silentTranslationWarn: true, // 忽略翻译警告
});

export default i18n;
